import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';

import ExpiryDateChip from './ExpiryChip';

export const ExpiringServicesGridColDef = () => {
    return [
        createColumnDef({
            field: 'serviceNumber',
            headerName: 'Service ID',
        }),
        createColumnDef({
            field: 'merchantAccountNumber',
            headerName: 'Merchant Account Number',
        }),
        createColumnDef({
            field: 'partnerName',
            headerName: 'Partner Name',
        }),
        createColumnDef({
            field: 'tradingName',
            headerName: 'Merchant Name',
        }),
        createColumnDef({
            field: 'expiryText',
            headerName: 'Expiring',
            align: 'center',
        }),
        createColumnDef({
            field: 'contractExpiry',
            headerName: 'Contract Expiry',
            type: 'date',
            renderCell: (params: GridRenderCellParams) => {
                if (!params.value) {
                    return <></>;
                }

                return <ExpiryDateChip date={new Date(params.value)} />;
            },
            valueGetter: (value: string) => {
                if (!value) {
                    return null;
                }

                return new Date(value);
            },
        }),
    ];
};

export default ExpiringServicesGridColDef;
